import { NgModule } from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {ExcelMemoRoutes} from './orbitax-excel-memo.routes';
import { ExcelMemoContentComponent } from './components/excel-memo-content/excel-memo-content.component';
import { ExcelMemoTemplateContentComponent } from './components/excel-memo-template-content/excel-memo-template-content.component';
import {WithholdingTaxMemoContentComponent} from './components/withholding-tax-memo-content/withholding-tax-memo-content';
import {RateMemoContentComponent} from './components/rate-memo-content/rate-memo-content.component';
import {FuseSplashScreenComponent} from './components/fuse-splash-screen/fuse-splash-screen.component';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { PlatformToolMemoHandler } from './services/platform-tool-memo-handler';
import { CorporateTaxPlatformMemoContentComponent } from './components/corporate-tax-view-memo/corporate-tax-view-platform-memo.component';
import { ViewMemoPlatformComponent } from './components/view-memo/view-memo-platform.component';
import { PlatformCommand } from '@shared/commands/command-base';
import { ExcelViewMemoComponent } from './components/excel-view-memo/excel-view-memo.component';
import {FuseSplashScreenPlatformComponent} from '@features/excel-memo/components/fuse-splash-screen-platform/fuse-splash-screen-platform.component';

@NgModule({
  declarations: [ExcelMemoContentComponent,
    ExcelMemoTemplateContentComponent,
    ExcelViewMemoComponent,
    RateMemoContentComponent,
    WithholdingTaxMemoContentComponent,
    CorporateTaxPlatformMemoContentComponent,
    FuseSplashScreenComponent,
    ViewMemoPlatformComponent,
    FuseSplashScreenPlatformComponent
  ],
  imports: [
    RouterModule.forChild(ExcelMemoRoutes),
    SharedModule
  ]
})
export class OrbitaxExcelMemoModule {
  constructor(private platformToolMemoHandler: PlatformToolMemoHandler) {
    RootDynamicComponentHelper.register('PlatformToolMemoHandler', platformToolMemoHandler);
    RootDynamicComponentHelper.register('CorporateTaxPlatformMemoContentComponent', CorporateTaxPlatformMemoContentComponent);
    RootDynamicComponentHelper.register('WithholdingTaxMemoContentComponent', WithholdingTaxMemoContentComponent);
    RootDynamicComponentHelper.register('ViewMemoPlatformComponent', ViewMemoPlatformComponent);
    RootDynamicComponentHelper.register('FuseSplashScreenPlatformComponent', FuseSplashScreenPlatformComponent);
    RootDynamicComponentHelper.register('ExcelMemoTemplateContentComponent', ExcelMemoTemplateContentComponent);
  }
 }
